<script lang="ts" setup>
import { scrollTo } from "~/helpers/functions/smoothScrool";
// scroll to top
import { useRoute } from "vue-router";
import { useIsProService } from "~/helpers/functions/IsProService";
const isProService = useIsProService();

const route = useRoute();
const isSinistrePage = computed(
  () => route.path === "/sinistre/declarer-un-sinistre"
);
const ringoverURL = `${import.meta.env.VITE_RINGOVER_LINK}`;
const clientPortalURL = `${import.meta.env.VITE_CLIENT_PORTAL_URL}`;

// 1st column
const aboutUsURL = `/qui-sommes-nous`;
const contactUs = `/contactez-nous`;
const legalMentionsURL = `/legal/mentions-legales`;
const privacyPoliciesURL = `/legal/politique-de-confidentialite`;
const cookiesURL = `/legal/politique-de-cookies`;

// 2nd column
const URLViewDirectory = `${clientPortalURL + "/directory"}`;
const NVEIInsurance = `/assurances/particuliers/deux-roues-electrique`;
const LegalProtectionInsurance = `/assurances/particuliers/protection-juridique`;
const CarInsurance = `/assurances/particuliers/auto`;

const ProfessionalMultiRiskInsurance = `/assurances/professionnelles/multirisque-professionnelle/`;
const HealthInsurance = `/assurances/particuliers/sante`;

// 3nd column
const contractCancellationURL = `/demande-de-resiliation-de-contrat`;
const URLDeclareClaim = `${clientPortalURL + "/sinistres/declaration"}`;
const howToClaimURL = `/sinistre/declarer-un-sinistre`;

// socials
const instagramURL = `https://www.instagram.com/tutassur/`;
const tiktokURL = `https://www.tiktok.com/@tutassur`;
const linkedinURL = `https://www.linkedin.com/company/tutass%C3%BBr/`;
const snapchatURL = `https://www.snapchat.com/add/tutassur`;

/**
 * Smoothly scrolls the window to the top.
 */
const scrollToTop = () => {
  scrollTo(0);
};

const redirectToRingover = () => {
  window.location.href = ringoverURL;
};
</script>
<template>
  <footer
    :class="{
      'pro-service': isProService,
      'footer-green': isSinistrePage,
      'footer-default': !isSinistrePage,
    }"
  >
    <!-- Footer header -->
    <div class="footer-header">
      <NuxtLink to="/">
        <img
          src="@/assets/img/white-logo.svg"
          :alt="$t('alt.logoTutassur')"
          class="logo"
        />
      </NuxtLink>

      <button class="back-to-top" @click="scrollToTop">
        <img
          v-if="!isProService"
          src="@/assets/img/custom/up-arrow-2.svg"
          :alt="$t('alt.scrollToTop')"
        />
        <img
          v-if="isProService"
          src="@/assets/img/custom/blue-up-arrow-2.svg"
          :alt="$t('alt.scrollToTop')"
        />
      </button>
      <button
        class="contact-us button-dimensions light-text"
        @click="redirectToRingover"
      >
        {{ $t("footer.contactUs") }}
      </button>
    </div>

    <!-- Main footer -->
    <nav class="main-footer">
      <!-- -------------- -->
      <div class="navbar-items">
        <p class="nav-title first-nav">{{ $t("footer.menu.about.title") }}</p>
        <div class="divider"></div>
        <div>
          <NuxtLink :to="aboutUsURL" class="nav-title">
            {{ $t("footer.menu.about.aboutUs") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="contactUs" class="nav-title">
            {{ $t("footer.menu.about.contactUs") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink to="/devenir-partenaire" class="nav-title">
            {{ $t("footer.menu.about.becomePartner") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="legalMentionsURL" class="nav-title">
            {{ $t("footer.menu.about.legalMentions") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="privacyPoliciesURL" class="nav-title">
            {{ $t("footer.menu.about.privacyPolicies") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="cookiesURL" class="nav-title">
            {{ $t("footer.menu.about.cookies") }}
          </NuxtLink>
        </div>
      </div>

      <!-- ---------------- -->
      <div class="navbar-items">
        <p class="nav-title first-nav">{{ $t("footer.menu.offres.title") }}</p>

        <div class="divider"></div>
        <div>
          <a :href="URLViewDirectory" class="nav-title">
            {{ $t("footer.menu.offres.professionalDirectory") }}
          </a>
        </div>
        <div>
          <NuxtLink :to="NVEIInsurance" class="nav-title">
            {{ $t("footer.menu.offres.NVEIInsurance") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :href="LegalProtectionInsurance" class="nav-title">
            {{ $t("footer.menu.offres.LegalProtectionInsurance") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="CarInsurance" class="nav-title">
            {{ $t("footer.menu.offres.CarInsurance") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="ProfessionalMultiRiskInsurance" class="nav-title">
            {{ $t("footer.menu.offres.ProfessionalMultiRiskInsurance") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="HealthInsurance" class="nav-title">
            {{ $t("footer.menu.offres.HealthInsurance") }}
          </NuxtLink>
        </div>
      </div>

      <!-- ----------------- -->
      <div class="navbar-items">
        <p class="nav-title first-nav">
          {{ $t("footer.menu.support.title") }}
        </p>

        <div class="divider"></div>
        <!-- hide for now-->
        <!--        <div>-->
        <!--          <a href="#" class="nav-title">-->
        <!--            {{ $t("footer.menu.support.FAQ") }}-->
        <!--          </a>-->
        <!--        </div>-->
        <div>
          <NuxtLink :to="contractCancellationURL" class="nav-title">
            {{ $t("footer.menu.support.ContractCancellation") }}
          </NuxtLink>
        </div>
        <div>
          <NuxtLink :to="howToClaimURL" class="nav-title">
            {{ $t("footer.menu.support.HowToClaim") }}
          </NuxtLink>
        </div>
        <div>
          <a :href="clientPortalURL" class="nav-title">
            {{ $t("footer.menu.support.CustomerArea") }}
          </a>
        </div>
        <div>
          <NuxtLink :href="URLDeclareClaim" class="nav-title">
            {{ $t("footer.menu.support.ReportClaim") }}
          </NuxtLink>
        </div>
      </div>
    </nav>

    <!-- Footer footer -->
    <div class="footer-footer">
      <p class="copyright">{{ $t("footer.copyright") }}</p>
      <ul class="socialmedia">
        <li class="soundEffect">
          <a :href="instagramURL">
            <img
              src="@/assets/img/social-media/instagram.svg"
              alt="instagram"
            />
          </a>
        </li>
        <li class="soundEffect">
          <a :href="tiktokURL">
            <img src="@/assets/img/social-media/tiktok.svg" alt="tiktok" />
          </a>
        </li>
        <li class="soundEffect">
          <a :href="linkedinURL">
            <img src="@/assets/img/social-media/linkedin.svg" alt="linkedin" />
          </a>
        </li>
        <li class="soundEffect">
          <a :href="snapchatURL">
            <img src="@/assets/img/social-media/snapchat.svg" alt="snapchat" />
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<style scoped>
* {
  color: var(--vt-c-white);
}

footer {
  background: transparent
    linear-gradient(180deg, #7448ef 0%, #412983 22%, #3a2478 100%) 0 0 no-repeat;
  border-radius: 35px 35px 0 0;
  opacity: 1;
  padding: 2rem 5rem;
}
.footer-green {
  background: transparent
    linear-gradient(180deg, #586c11 0%, #313c09 22%, #313c09 100%) 0% 0%
    no-repeat padding-box;
}
.pro-service {
  background: transparent
    linear-gradient(180deg, #4855ef 0%, #1d2369 22%, #1d2369 100%) 0% 0%
    no-repeat padding-box;
}
.footer-header {
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1rem 0;
  margin-bottom: 4rem;
}

.footer-header .logo {
  width: 193px;
  height: 57px;
  justify-self: start;
}
.contact-us {
  border: 1px solid var(--vt-c-white);
  opacity: 1;
  background: transparent;
  justify-self: end;
}
nav {
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4rem;
}

nav a {
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
  color: var(--vt-c-white);
  opacity: 0.8;
  transition: all 0.3s ease;
}
nav a:hover {
  text-decoration: underline var(--vt-c-white);
}
.footer-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.footer-footer p {
  letter-spacing: 0;
  opacity: 0.7;
}
.footer-footer ul {
  display: flex;
  gap: 1.5rem;
  padding: 0;
}
.back-to-top {
  background-color: transparent;
  outline: none;
  justify-self: center; /* Center the back-to-top button */

  border: none;
  border: 1px solid var(--vt-c-white);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  width: 56px;
  height: 56px;
}
.back-to-top img {
  height: 1.5rem;
  width: auto;
  filter: brightness(0) invert(1);
}
.back-to-top:hover img {
  filter: initial;
}
.back-to-top:hover {
  background-color: white;
  box-shadow: 1px 1px 29px var(--vt-c-white);
}

/* .socialmedia img {
  width: 100%;
} */

.logo {
  transition: filter 0.3s ease-in-out; /* Ajoute une animation fluide pour l'ombre */
}

.logo:hover {
  filter: drop-shadow(0 0 5px white); /* Ombre blanche douce */
}

.socialmedia li {
  transition: all 0.3s ease;
}

.socialmedia li:hover {
  box-shadow:
    inset 0 3px 6px #00000029,
    0 3px 20px var(--vt-c-white);
}

li img {
  display: block;
}
li {
  list-style: none;
  border-radius: 12px;
}
.contact-us:hover {
  background-color: var(--vt-c-white);
  color: var(--vt-c-purple);
  box-shadow: 1px 1px 29px var(--vt-c-white);
}
.pro-service .contact-us:hover {
  color: var(--vt-c-blue);
}
/* main footer */
.main-footer {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
}
.divider {
  width: 18rem;
  padding: 0;
  border-bottom: 1px solid #a7a7a7;
}
.navbar-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.main-footer .first-nav {
  text-align: left;
  text-align: center;
  padding: 0;
  margin: 0;
  font: normal normal normal 22px/30px "Gilmer Bold";
}
.main-footer a {
  text-align: center;
  font-size: 22px;
  line-height: 22px;
}
.main-footer a:hover {
  text-decoration: underline;
}
/* copyrihgt */
.copyright {
  text-align: center;
  font: normal normal normal 20px/28px "Gilmer Light";
  letter-spacing: 0;
}
@media screen and (max-width: 900px) {
  .button-dimensions {
    width: 292px;
  }
}
@media screen and (max-width: 780px) {
  .main-footer {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 4rem;
  }
  .main-footer a,
  .main-footer .first-nav {
    font-size: 17px;
  }
  footer {
    padding: 3.5rem 0 4rem;
  }
  nav ul {
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
  }
  .footer-header {
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    justify-content: space-around;
    align-items: center;
  }
  .footer-header .logo {
    margin-left: 2.5rem;
    width: 119px;
    height: 35px;
  }
  .back-to-top {
    justify-self: end;
    width: 51px;
    height: 51px;
    margin-right: 2.5rem;
  }
  .contact-us {
    margin: 0 auto;
    margin-top: 2.5rem;
    grid-column: span 2;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: unset;
    padding: 0;
  }

  /* .divider {
    display: none;
  } */
  li a {
    font-size: 1.2rem;
  }
  li a img {
    width: 28px;
    height: 28px;
  }
  nav {
    padding: 0.75rem 1.75rem;
  }
  .footer-footer {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
  }
  .copyright {
    text-align: center;
    font: normal normal normal 15px/21px "Gilmer Light";
    /* margin-bottom: 5rem; */
  }
}
</style>
